export default __webpack_public_path__ + "static/media/logo-my.df9849fe.png";